import { render } from "./submitGame.vue?vue&type=template&id=a4a1c91c&scoped=true"
import script from "./submitGame.vue?vue&type=script&lang=js"
export * from "./submitGame.vue?vue&type=script&lang=js"

import "./submitGame.vue?vue&type=style&index=0&id=a4a1c91c&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a1c91c"]])

export default __exports__